import { cn } from '@/lib/utils';

import type { ComponentProps } from 'react';

const Message = ({
  className,
  align = 'start',
  ...props
}: ComponentProps<'div'> & { align?: 'start' | 'end' }) => (
  <div
    data-slot="message"
    data-align={align}
    className={cn(
      'group/message relative flex w-full min-w-0 gap-2 text-sm data-[align=end]:flex-row-reverse',
      className
    )}
    {...props}
  />
);

const MessageContent = ({ className, ...props }: ComponentProps<'div'>) => (
  <div
    data-slot="message-content"
    className={cn(
      'flex w-full min-w-0 flex-col gap-1.5 break-words group-data-[align=end]/message:[&>[data-slot]]:self-end',
      className
    )}
    {...props}
  />
);

export { Message, MessageContent };
